import Vue from 'vue';
import { inArray } from './miscellanea';

export default class Errors {
  private errors: any = {};

  constructor(fields: Array<string>) {
    fields.forEach(f => {
      this.errors[f] = [];
    });
  }

  has(field: string) {
    // eslint-disable-next-line no-prototype-builtins
    return this.errors.hasOwnProperty(field) && this.errors[field].length > 0;
  }

  any(): boolean {
    return Object.keys(this.errors).length > 0;
  }

  get(field: string | null) {
    if (field) return this.errors[field];
    return this.errors;
  }

  record(errors: any) {
    this.errors = errors;
  }

  add(field: string, error: string) {
    if (this.errors[field] && !inArray(error, this.errors[field])) {
      this.errors[field].push(error);
    } else {
      const _error = [error];
      Vue.set(this.errors, field, _error);
    }
  }

  clear(field: string | null = null) {
    if (field) {
      this.errors[field] = [];
      return;
    }

    this.errors = {};
  }
}
